export default "__VITE_ASSET__8bd444a3__"